module.exports = __webpack_public_path__ + "static/media/interconnect.ba7021a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/interconnect.jpg
// module id = 1624
// module chunks = 0